// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduledItem_CcifT {
  display: flex;
  flex-direction: column;
  gap: 10px;
input:disabled,
textarea:disabled{
  background-color: transparent;
  cursor: initial;
}
.toggleSwitch_vIs4E {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  margin-bottom: 0;
}

.toggleSwitch_vIs4E input {
  opacity: 0;
  width: 0 !important;
  height: 0 !important;
  display: none;
  cursor: pointer;
}

.slider_SSQMs {
  position: absolute;
  background-color: #ccc;
  border-radius: 24px;
  width: 100%;
  height: 100%;
  transition: background-color 0.3s;
  left: 0;
}

.slider_SSQMs::before {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 2px;
  background-color: var(--white-color);
  border-radius: 50%;
  transition: transform 0.3s;
}

.toggleSwitch_vIs4E input:checked + .slider_SSQMs {
  background-color: var(--_10a37f-background);
}

.toggleSwitch_vIs4E input:checked + .slider_SSQMs::before {
  transform: translateX(14px);
  -webkit-transform: translateX(14px);
  -moz-transform: translateX(14px);
  -ms-transform: translateX(14px);
  -o-transform: translateX(14px);
}
.deleteButtonBlack_IOe8G{
  cursor: pointer;
}
  .responseheader_x83si {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .inputTitle_ouh6d{
      max-width: 250px;
    }
    .optionsResponsesGrab__iVRe {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    .responseInfo_FEXQk {
      color: #92959862;
      display: flex;
      align-items: center;
    }
    .grabIcon_kbnKc {
      outline: none;
      border: none;
      background-color: transparent;
      cursor: grab;
      display: flex;
      align-items: center;
    }
  }

  .responsesBlock_stZYz {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .responseItem_Fg90r {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .addResponse_Z73yq {
    outline: none;
    border: 1px solid #b8b8b8;
    border-radius: 4px;
    height: 28px;
    width: 26px;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
  }
  
  input,textarea {
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    color: var(--_75-color);
    background-color: var(--f4-background);
    border-radius: 5px;
    box-sizing: border-box;
    width: 100%;
    field-sizing: content;
    min-height: 21px !important;
    padding: 8px;
    font-family: "Inter", sans-serif;
    box-sizing: border-box;
    resize: none;
    &::placeholder{
      color: var(--_75-color);
    }
  }
}





.responsesBlock_stZYz {
  overflow: hidden;
  transition: height 0.3s ease;
}

.expand_ad8OX {
  height: auto;
  padding-top: 12px;
}

.collapse_FvYOG {
  height: 0;
  padding-top: 0;
}


.ArrowDown_r3Pzo{
  transition: transform 0.3s ease;
  cursor: pointer;
}

.rotatedArrow_dLnwc {
  transform: rotate(180deg);
}

.EntryContainer_Djnjy{
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
}
.questionGroup_HXpay{
  display: flex;
  flex-direction: column;
  gap: 15px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewAgentComponent/ScheduledResponses/ResponsesGrab/ResponsesGrab.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;EAEE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,OAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB;MACE,gBAAgB;IAClB;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;IACV;IACA;MACE,gBAAgB;MAChB,aAAa;MACb,mBAAmB;IACrB;IACA;MACE,aAAa;MACb,YAAY;MACZ,6BAA6B;MAC7B,YAAY;MACZ,aAAa;MACb,mBAAmB;IACrB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,YAAY;IACZ,gCAAgC;IAChC,sBAAsB;IACtB,YAAY;IACZ;MACE,uBAAuB;IACzB;EACF;AACF;;;;;;AAMA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;;AAGA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".scheduledItem {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\ninput:disabled,\ntextarea:disabled{\n  background-color: transparent;\n  cursor: initial;\n}\n.toggleSwitch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 24px;\n  margin-bottom: 0;\n}\n\n.toggleSwitch input {\n  opacity: 0;\n  width: 0 !important;\n  height: 0 !important;\n  display: none;\n  cursor: pointer;\n}\n\n.slider {\n  position: absolute;\n  background-color: #ccc;\n  border-radius: 24px;\n  width: 100%;\n  height: 100%;\n  transition: background-color 0.3s;\n  left: 0;\n}\n\n.slider::before {\n  content: \"\";\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  left: 4px;\n  bottom: 2px;\n  background-color: var(--white-color);\n  border-radius: 50%;\n  transition: transform 0.3s;\n}\n\n.toggleSwitch input:checked + .slider {\n  background-color: var(--_10a37f-background);\n}\n\n.toggleSwitch input:checked + .slider::before {\n  transform: translateX(14px);\n  -webkit-transform: translateX(14px);\n  -moz-transform: translateX(14px);\n  -ms-transform: translateX(14px);\n  -o-transform: translateX(14px);\n}\n.deleteButtonBlack{\n  cursor: pointer;\n}\n  .responseheader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    .inputTitle{\n      max-width: 250px;\n    }\n    .optionsResponsesGrab {\n      display: flex;\n      align-items: center;\n      gap: 5px;\n    }\n    .responseInfo {\n      color: #92959862;\n      display: flex;\n      align-items: center;\n    }\n    .grabIcon {\n      outline: none;\n      border: none;\n      background-color: transparent;\n      cursor: grab;\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  .responsesBlock {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n  .responseItem {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  .addResponse {\n    outline: none;\n    border: 1px solid #b8b8b8;\n    border-radius: 4px;\n    height: 28px;\n    width: 26px;\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    padding: 0;\n  }\n  \n  input,textarea {\n    border: none;\n    outline: none;\n    font-size: 14px;\n    font-weight: 400;\n    color: var(--_75-color);\n    background-color: var(--f4-background);\n    border-radius: 5px;\n    box-sizing: border-box;\n    width: 100%;\n    field-sizing: content;\n    min-height: 21px !important;\n    padding: 8px;\n    font-family: \"Inter\", sans-serif;\n    box-sizing: border-box;\n    resize: none;\n    &::placeholder{\n      color: var(--_75-color);\n    }\n  }\n}\n\n\n\n\n\n.responsesBlock {\n  overflow: hidden;\n  transition: height 0.3s ease;\n}\n\n.expand {\n  height: auto;\n  padding-top: 12px;\n}\n\n.collapse {\n  height: 0;\n  padding-top: 0;\n}\n\n\n.ArrowDown{\n  transition: transform 0.3s ease;\n  cursor: pointer;\n}\n\n.rotatedArrow {\n  transform: rotate(180deg);\n}\n\n.EntryContainer{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 20px;\n}\n.questionGroup{\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scheduledItem": `scheduledItem_CcifT`,
	"toggleSwitch": `toggleSwitch_vIs4E`,
	"slider": `slider_SSQMs`,
	"deleteButtonBlack": `deleteButtonBlack_IOe8G`,
	"responseheader": `responseheader_x83si`,
	"inputTitle": `inputTitle_ouh6d`,
	"optionsResponsesGrab": `optionsResponsesGrab__iVRe`,
	"responseInfo": `responseInfo_FEXQk`,
	"grabIcon": `grabIcon_kbnKc`,
	"responsesBlock": `responsesBlock_stZYz`,
	"responseItem": `responseItem_Fg90r`,
	"addResponse": `addResponse_Z73yq`,
	"expand": `expand_ad8OX`,
	"collapse": `collapse_FvYOG`,
	"ArrowDown": `ArrowDown_r3Pzo`,
	"rotatedArrow": `rotatedArrow_dLnwc`,
	"EntryContainer": `EntryContainer_Djnjy`,
	"questionGroup": `questionGroup_HXpay`
};
export default ___CSS_LOADER_EXPORT___;
